import { render } from "./CookieDisclaimer.vue?vue&type=template&id=25e4e408&scoped=true"
import script from "./CookieDisclaimer.vue?vue&type=script&lang=js"
export * from "./CookieDisclaimer.vue?vue&type=script&lang=js"

import "./CookieDisclaimer.vue?vue&type=style&index=0&id=25e4e408&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25e4e408"]])

export default __exports__